<template>
    <app-modal modal-id="details-view-modal" modal-size="fullscreen" modal-alignment="top" @close-modal="closeModal">
        <template slot="header">
            <h4>{{ pageHeader }}</h4>
            <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-table :id="'report-deal-details-table'" :options="options"/>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click.prevent="closeModal">
                {{ $t('close') }}
            </button>
        </template>
    </app-modal>
</template>

<script>
    import {numberWithCurrencySymbol, formatDateTimeToLocal, numberFormatter} from "../../../../Helpers/helpers";

    export default {
        name: "ReportDealDetails",
        props:['groupBy', 'id', 'filterValue', 'pageHeader', 'statusLostId'],
        data() {
            return {
                numberWithCurrencySymbol, formatDateTimeToLocal, numberFormatter,
                options: {
                    tablePaddingClass: "px-0",
                    tableShadow: false,
                    name: 'report-deal-details-table',
                    url: 'crm/deal-report-details?' + 'groupBy=' + this.groupBy +
                    '&id='+ this.id + '&status='+this.filterValue.status+'&pipeline='+this.filterValue.pipeline+'&pay_is='+this.filterValue.pay_is+'&instage_is='+this.filterValue.instage_is+'&date='+this.filterValue.date+'',
                    showHeader: true,
                    columns: [
						{
          					title: this.$t("id"),
          					type: "text",
							key: "id",
        				},
                        {
                            title: this.$t('deal_name'),
                            type: 'text',
                            key: 'title'
                        },
                    
                        
                        {
                            title: this.$t('deal_value'),
                            type: 'custom-html',
                            key: 'value',
                            modifier: (value) => {
                                return `<p class="text-nowrap">${numberWithCurrencySymbol(value)}</p>`;
                            },
                        },
                        {
						 	title: this.$t("created_at"),
          					type: "custom-html",
          					key: "created_at",
          					modifier: (value, row) => {
           						 return value
              					? `<span>${formatDateTimeToLocal(row.created_at)}</span>`
								: "-";
								},
        				},
                    ],
                    showSearch: false,
                    showFilter: false,
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    orderBy: 'desc',
                    actionType: "dropdown",
                }
            }
        },
        methods: {
            closeModal(value){
                this.$emit('close-modal', value);
            },
       
           
        }
    }
</script>
